import { alpha, darken, lighten } from '@material-ui/core/styles';

// interface paletteSettings {
//   color: Record<string, unknown>;
//   custom: {
//     primary: Record<string, unknown>;
//   };
//   greyscale: Record<string, unknown>;
//   transparent: {
//     dark: Record<string, unknown>;
//     light: Record<string, unknown>;
//   };
// }

export const getPalette = (primaryColor: string) => ({
  color: {
    error: '#D80034',
    info: '#5970E5',
    success: '#20C26E',
    warning: '#FF6624',
  },
  custom: {
    primary: {
      dark: darken(primaryColor, 0.05),
      light: lighten(primaryColor, 0.2),
      lighter: lighten(primaryColor, 0.4),
      main: primaryColor,
    },
  },
  greyscale: {
    0: '#FFFFFF',
    200: '#EDEDED',
    400: '#CCCCCC',
    500: '#B3B3B3',
    600: '#999999',
    800: '#666666',
    1000: '#000000',
  },
  transparent: {
    dark: {
      200: alpha('#000000', 0.2),
      500: alpha('#000000', 0.5),
      800: alpha('#000000', 0.8),
      900: alpha('#000000', 0.9),
    },
    light: {
      200: alpha('#FFFFFF', 0.2),
      500: alpha('#FFFFFF', 0.5),
      800: alpha('#FFFFFF', 0.8),
      900: alpha('#FFFFFF', 0.9),
    },
  },
});
